import { render } from "./PlanFormModal.vue?vue&type=template&id=04e88af6&scoped=true"
import script from "./PlanFormModal.vue?vue&type=script&lang=js"
export * from "./PlanFormModal.vue?vue&type=script&lang=js"

import "./PlanFormModal.vue?vue&type=style&index=0&id=04e88af6&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04e88af6"]])

export default __exports__